import Vue from 'vue'
import Router from 'vue-router'
import Root from '@/components/Root'

Vue.use(Router)

export default new Router({
  routes: [
	  {
		  path: '/',
		  name: 'Root',
		  component: Root,
		  props: (route) => ({
	        teamcode: route.query.teamcode,
	        resp_id: route.query.resp_id,
	        challenge_token: route.query.challenge_token,
	      }),
	  },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js